import React from "react";
import { useNavigate } from "react-router-dom";
import { Coins, Gem, Flame, Star, Volume2, VolumeX } from "lucide-react";
import { useProfile } from "../context/ProfileContext";
import { MASCOTS, auraStyle } from "../data/gameData";

export default function TopBar() {
  const { profile, soundMuted, setSoundMuted } = useProfile();
  const navigate = useNavigate();
  if (!profile) return null;
  const mascot = MASCOTS[profile.mascot] || MASCOTS.lumi;
  const pct = Math.min(100, Math.round((profile.level_xp / profile.level_xp_needed) * 100));
  const aura = auraStyle(profile.equipped?.aura);

  return (
    <div className="sticky top-0 z-40 glass-dark px-4 py-3" data-testid="top-bar">
      <div className="max-w-4xl mx-auto flex items-center gap-3">
        <button
          data-testid="topbar-profile-btn"
          onClick={() => navigate("/profile")}
          className="flex items-center gap-3 press">
          <div className="relative w-11 h-11 rounded-full overflow-hidden border-2"
               style={{ borderColor: mascot.color, ...aura }}>
            <img src={mascot.img} alt={mascot.name} className="w-full h-full object-cover" />
          </div>
          <div className="text-left leading-tight">
            <div className="text-sm font-bold" data-testid="topbar-name">{profile.name}</div>
            <div className="text-[11px] text-[#A8B2D1] flex items-center gap-1">
              <Star size={11} className="text-[#FFD600]" fill="#FFD600" /> Level {profile.level}
            </div>
          </div>
        </button>

        <div className="flex-1 mx-1">
          <div className="h-2.5 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full rounded-full transition-all"
                 style={{ width: `${pct}%`, background: "linear-gradient(90deg,#FF2A7A,#00E5FF)" }} />
          </div>
        </div>

        <div className="flex items-center gap-2 text-sm font-bold">
          <button
            data-testid="topbar-mute-btn"
            onClick={() => setSoundMuted(!soundMuted)}
            className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center press">
            {soundMuted ? <VolumeX size={16} className="text-[#A8B2D1]" /> : <Volume2 size={16} className="text-[#00E5FF]" />}
          </button>
          <span className="hidden sm:flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/5"
                data-testid="topbar-streak">
            <Flame size={15} className="text-[#FF7A00]" /> {profile.streak}
          </span>
          <button onClick={() => navigate("/shop")}
                  className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/5 press"
                  data-testid="topbar-coins">
            <Coins size={15} className="text-[#FFD600]" /> {profile.coins}
          </button>
          <span className="hidden sm:flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/5"
                data-testid="topbar-gems">
            <Gem size={15} className="text-[#00E5FF]" /> {profile.gems}
          </span>
        </div>
      </div>
    </div>
  );
}
